import { render, staticRenderFns } from "./CaseHistory.vue?vue&type=template&id=ccb8c1be&scoped=true&"
import script from "./CaseHistory.vue?vue&type=script&lang=js&"
export * from "./CaseHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb8c1be",
  null
  
)

export default component.exports